import _ from "lodash";
import React, { useCallback, useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import FullScreenLoader from "../../components/widgets/FullScreenLoader";
import { StyleTypeContext } from "../../umbilical_tools";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { flightsErrorMsgs } from "../../errors";
import {
  flightSearchFormUpdate,
  singleFlightSearch,
} from "../../actions/search/flights_search";
import { validateFlightSearch } from "../../components/MainSearchForm/flights/helpers";
import { useApoAuth } from "../../hooks";

function recreateFormData(decoded_data) {
  var data = {
    origin: {
      origin_meta: [
        { iata: decoded_data.orgn_ia, label: decoded_data.orgn_nm },
      ],
    },
    destination: {
      destination_meta: [
        { iata: decoded_data.dest_ia, label: decoded_data.dest_nm },
      ],
    },
    outbound_departure: decoded_data.out,
    adults: decoded_data.adt,
    children: decoded_data.chd,
    children_ages: decoded_data.ages,
    isRoundTrip: decoded_data.rTrp,
    baggage_only: decoded_data.bags,
    stops: decoded_data.stops,
    flight_class: decoded_data.cls,
  };
  if (decoded_data.in) data = { ...data, inbound_departure: decoded_data.in };
  return data;
}

const styles = createUseStyles({
  DeepFlightSearch: (props) => ({
    position: "absolute",
    background: "#FAFAFA",
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    ...(props?.customStyles.DeepFlightSearch ?? {}),
  }),
});
function DeepFlightSearch({ encoded_data }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({ type, brand, objName: "DeepFlightSearch" });

  const classes = styles({ customStyles });

  const { source_entity, market_type, website_api_key } = useApoAuth();

  function onError() {
    toast.warning(flightsErrorMsgs.searchForm.init_search, { duration: 5000 });
    history.push("/");
  }

  var decoded_data = {};
  try {
    decoded_data = recreateFormData(JSON.parse(window.atob(encoded_data)));
  } catch (error) {
    onError();
  }

  const onFormUpdate = useCallback(
    async (form) => dispatch(flightSearchFormUpdate({ form })),
    [dispatch]
  );

  const onFormSearch = useCallback(() => {
    dispatch(
      singleFlightSearch({
        history,
        source_entity,
        market_type,
        website_api_key,
      })
    );
  }, [dispatch]);

  async function onSearch(form) {
    await onFormUpdate(form);
    onFormSearch();
  }

  // Execute search
  useEffect(() => {
    if (!source_entity) {
      onError();
      return;
    }
    if (_.isEmpty(decoded_data)) return;

    if (!validateFlightSearch(decoded_data)) {
      onError();
      return;
    }

    onSearch(decoded_data);
  }, [encoded_data, source_entity]);

  return (
    <div className={classes.DeepFlightSearch}>
      <FullScreenLoader />
    </div>
  );
}
DeepFlightSearch.propTypes = { encoded_data: PropTypes.string.isRequired };
export default DeepFlightSearch;
